import React, { useState } from "react";
import StopIcon from "@material-ui/icons/Stop";
import FlightLandIcon from "@material-ui/icons/FlightLand";
import TimerOffIcon from "@material-ui/icons/TimerOff";
import { OrderStates, updatedStoredOrder } from "../../helpers";
import api from "../../../../services/api";
import "./style.css";

export default ({ simulations, onStoredSimulationsUpdated }) => {
  const [isUpdatingOrder, setIsUpdatingOrder] = useState(false);

  const updateOrderStatus = async (simulation, newStatus) => {
    switch (newStatus) {
      case OrderStates.ARRIVED:
      case OrderStates.STOPPED:
      case OrderStates.TIMEOUT:
        break;
      default:
        throw new Error("Invalid update state provided for order");
    }
    if (isUpdatingOrder) {
      return;
    }
    setIsUpdatingOrder(true);
    await api.updateSimulatedTempoOrder(simulation, newStatus);
    updatedStoredOrder(simulation.orderId, newStatus);
    onStoredSimulationsUpdated();
    setIsUpdatingOrder(false);
  };

  return (
    <div className="simulation-list-wrapper">
      <h4 className="simulation-list-header">ACTIVE SIMULATIONS</h4>
      {simulations.length ? (
        <div className="simulation-table-wrapper">
          <table className="simulation-table">
            <thead>
              <tr className="simulation-table-header-row">
                <th>Zone</th>
                <th>Project</th>
                <th>Customer</th>
                <th>Order ID</th>
                <th>Destination</th>
                <th className="simulation-table-icon-header">Arrive Now</th>
                <th className="simulation-table-icon-header">Timeout</th>
                <th className="simulation-table-icon-header">Stop</th>
              </tr>
            </thead>
            <tbody>
              {simulations.map((simulation) => (
                <tr key={simulation.orderId}>
                  <td>{simulation.zone.name}</td>
                  <td>{simulation.project.name}</td>
                  <td>{simulation.customerName}</td>
                  <td>{simulation.orderId}</td>
                  <td>{simulation.zone.destinationId}</td>
                  <td>
                    <div className="icon-wrapper">
                      <FlightLandIcon
                        className="simulator-icon arrive-now-icon"
                        onClick={() =>
                          updateOrderStatus(simulation, OrderStates.ARRIVED)
                        }
                      />
                    </div>
                  </td>
                  <td>
                    <div className="icon-wrapper">
                      <TimerOffIcon
                        className="simulator-icon timeout-icon"
                        onClick={() =>
                          updateOrderStatus(simulation, OrderStates.TIMEOUT)
                        }
                      />
                    </div>
                  </td>
                  <td>
                    <div className="icon-wrapper">
                      <StopIcon
                        className="simulator-icon stop-icon"
                        onClick={() =>
                          updateOrderStatus(simulation, OrderStates.STOPPED)
                        }
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <h4 className="no-simulations-message">
          You don't have any active simulations
        </h4>
      )}
    </div>
  );
};
